import { useEffect } from "react";
import { Channel, DialogType, Topic } from "../constants/index.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { AlbertaMigrationUtils, MessageBrokerUtils } from "../utils/index.js";
import { useFeatureFlag } from "./useFeatureFlag.js";

export const useAlbertaMigrationBlock = () => {
  const isAlbertaMigrationBlockEnabled = useFeatureFlag(
    AppFeatures.ALBERTA_MIGRATION_BLOCK
  );

  useEffect(() => {
    if (!isAlbertaMigrationBlockEnabled) return;
    if (!AlbertaMigrationUtils.isAlbertaPlayer()) return;

    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.DialogShow,
      headers: { publisher: "UAA" },
      data: { dialogType: DialogType.AlbertaMigrationBlock }
    });
  }, [isAlbertaMigrationBlockEnabled]);
};
